
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { UsersService, InterfacePermissions } from "../services/users.service";

@Injectable()
export class AuthGuard {
  constructor(private auth: UsersService, public router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>{
    let requirement = route.data["access_requirement"] as InterfacePermissions;
    return observableOf(this.auth.InterfaceIsPermitted(requirement));
  }

}
